import React from "react";
import styles from "./index.module.scss";
import Button from "@Components/Button";
import { DragAndDropUploader } from "@Components/DragAndDropUploader";
import PredictyIconEyesOpen from "@Components/Icons/ChatBot/Predicty/PredictyEyesOpen";
import CSVIcon from "@Components/Icons/CSV";
import Exit from "@Components/Icons/Exit";
export function Manual(props) {
    return (React.createElement("div", { className: styles.card },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement("svg", { className: styles.fileIcon, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("path", { d: "M9.33333 1.33333H4C3.26362 1.33333 2.66667 1.93029 2.66667 2.66667V13.3333C2.66667 14.0697 3.26362 14.6667 4 14.6667H12C12.7364 14.6667 13.3333 14.0697 13.3333 13.3333V5.33333L9.33333 1.33333Z", stroke: "#0eabdb", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                        React.createElement("path", { d: "M9.33333 1.33333V5.33333H13.3333", stroke: "#0eabdb", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                        React.createElement("path", { d: "M5.33333 8H10.6667", stroke: "#0eabdb", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                        React.createElement("path", { d: "M5.33333 10.6667H10.6667", stroke: "#0eabdb", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
                React.createElement("h4", { className: styles.title }, "Manually upload your Bill\u00A0Reports")),
            React.createElement("div", { className: styles.formContainer },
                React.createElement(PredictyIconEyesOpen, { className: styles.predictyIcon }),
                React.createElement(DragAndDropUploader, { validate: (file) => {
                        const fileTypeRegex = /.*\.(csv|pdf)$/;
                        return fileTypeRegex.test(file.name);
                    }, submit: props.submit, content: ({ files, remove, submit, click }) => {
                        let fileDisplay;
                        let summaryDisplay;
                        let itemisedDisplay;
                        if (files.length > 0) {
                            fileDisplay = (React.createElement("div", { className: styles.files },
                                React.createElement("h3", null, "Your files"),
                                React.createElement("div", { className: styles.fileList }, files.map(({ id, name, }) => (React.createElement("div", { key: id, className: styles.file },
                                    React.createElement("div", { className: styles.fileDetails },
                                        React.createElement("div", { className: styles.CSVicon },
                                            React.createElement(CSVIcon, null)),
                                        React.createElement("p", null, name),
                                        React.createElement("span", { className: styles.exit, onClick: () => remove(id) },
                                            React.createElement(Exit, { error: true, size: "0.75rem" }))))))),
                                files.length >= 2 && (React.createElement("div", { className: styles.buttons },
                                    React.createElement(Button, { click: click }, "ADD FILES"),
                                    files.length >= 4 && (React.createElement(Button, { click: submit }, "UPLOAD"))))));
                        }
                        if (files.length === 0) {
                            summaryDisplay = (React.createElement("div", { className: styles.noFiles },
                                React.createElement("div", { className: styles.sectionTitle }, "Summary Report"),
                                React.createElement("p", { className: styles.subtitle }, "We need your most recent full month's report"),
                                React.createElement(Button, { click: click, newBlueOutlinedCta: true }, "SELECT CSV FOR UPLOAD")));
                        }
                        if (files.length < 2) {
                            itemisedDisplay = (React.createElement("div", { className: styles.noFiles },
                                React.createElement("div", { className: styles.sectionTitle }, "Itemised Reports"),
                                React.createElement("p", { className: styles.subtitle },
                                    "We need a min. of",
                                    " ",
                                    React.createElement("span", { className: styles.highlight }, "three"),
                                    " ",
                                    "months of reports"),
                                React.createElement(Button, { click: click, newBlueOutlinedCta: true }, "SELECT CSVS FOR UPLOAD")));
                        }
                        return (React.createElement("div", { className: styles.body },
                            fileDisplay,
                            summaryDisplay,
                            itemisedDisplay));
                    }, onUpload: (files) => {
                        if (files.length >= 4) {
                            props.submit(files);
                        }
                    } }))),
        React.createElement("div", { className: styles.bottom }, props.bottomSlot)));
}
export default Manual;
